import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import moment from 'moment';
import { CountDownTimer } from 'framework/ui/ui-builder';
import { useFieldHelper } from 'framework/ui/field';
import { DATE_FORMAT } from 'framework/utils';
import { PROGRESS_FIELDS_KEYS } from 'domain/sales/projectsDashboard/useProjectsDashboardService';

interface TimeInProgressFieldProps {
  source: string;
  customerActivityDurationSource: string;
  shouldCountFromTargetDate?: boolean;
  progressSource: string;

  [key: string]: any;
}

const timerLabelSx = {
  mt: '10px',
  mb: '1px',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  '&:first-of-type': {
    mt: 0,
  },
};

const TimeInProgressField = ({
  source,
  customerActivityDurationSource,
  progressSource,
  shouldCountFromTargetDate = false,
}: TimeInProgressFieldProps) => {
  const { getValue: getTime } = useFieldHelper({ source });
  const { getValue: getCustomerActivityDuration } = useFieldHelper({ source: customerActivityDurationSource });
  const { getValue: getProgress } = useFieldHelper({ source: progressSource });
  const customerActivityDuration = +getCustomerActivityDuration() || 0;
  const timerValue = getTime();
  const shortTimerValue = useMemo(
    () => moment(timerValue).add(customerActivityDuration, 'days').format(DATE_FORMAT.API),
    [timerValue, customerActivityDuration],
  );

  const progress = getProgress() as unknown as any[];
  const lastStep = progress.find(step => step.stepName === PROGRESS_FIELDS_KEYS.MVP);
  const lastStepFactDate = lastStep?.factDate;

  return (
    <Stack alignItems="center" justifyContent="center">
      <Typography variant="caption" sx={timerLabelSx}>
        With customer confirmation
      </Typography>
      <CountDownTimer
        targetDate={timerValue}
        shouldCountFromTargetDate={shouldCountFromTargetDate}
        stopDatetime={lastStepFactDate}
      />

      <Typography variant="caption" sx={timerLabelSx}>
        Without customer confirmation
      </Typography>
      <CountDownTimer
        targetDate={shortTimerValue}
        shouldCountFromTargetDate={shouldCountFromTargetDate}
        stopDatetime={lastStepFactDate}
      />
    </Stack>
  );
};

export default TimeInProgressField;
